import m from "mithril"
import { MithrilTsxComponent } from "mithril-tsx-component"

export class Icon extends MithrilTsxComponent<{ icon: string }>{
  view(v) {
    return <i className="material-icons">{v.attrs.icon}</i>
  }
}